/* cache-bust 20260807 */
/* cache-bust-20260807
 * sr-controller.js v3.15 — 应答器
 * 最后修改: 2026-08-05 v3.8
 * v3.8: 修复 cookie.write 参数类型；移除 email 流程中的 persist()，KV 留给出口写
 * 
 * v3.3 变更:
 *   - 废弃 sr-global，所有通知统一走 on() 回调
 *   - 不广播，不存在 DOM 事件
 *   - 谁发问谁收回答，C 端同时通知相关方
 * 
 * 架构：
 *   UI 产生动作 → Controller 处理 → 返回 { stateCode, data }
 *   → 点对点通知：
 *     1. 缘起方：route() 返回 Promise，直接拿结果
 *     2. 相关方：通过 on() 注册回调，Controller 主动调用
 *   - 没有广播，没有 DOM 事件，没有 window.srGlobal
 */

(function() {
  'use strict';

  var WORKER_URL = 'https://workerapi.sandalwoodritual.com';

  // 状态码
  var STATES = {
    VISITOR: 1,
    MEMBER: 2,
    EMAIL_INVALID: 3,
    EMAIL_CONFLICT: 4,
    PENDING_CONFIRM: 5,
    EMAIL_CHANGED: 6,
    OTP_SENT: 7,
    OTP_VERIFIED: 8,
    ERROR: 9
  };

  // ============================================================
  // 事件系统：点对点显式通知，不广播
  // ============================================================
  
  // 回调注册表：{ 'member-changed': [fn1, fn2], ... }
  var _callbacks = {};
  
  // 事件映射：action → event（Controller 知道哪些操作触发哪些事件）
  var EVENT_MAP = {
    'init': 'member-changed',
    'email': 'member-changed',
    'otp': 'member-changed',
    'update': 'member-changed',
    'cart.open': 'cart-changed',
    'cart.close': 'cart-changed',
    'cart.save': 'cart-changed'
  };
  
  /**
   * 注册回调（相关方用这个）
   * 谁需要知道变化，谁就 on()。Controller 处理完后主动通知。
   */
  function on(event, callback) {
    if (!_callbacks[event]) _callbacks[event] = [];
    _callbacks[event].push(callback);
  }
  
  /**
   * 触发事件 — 点对点，只通知已注册的相关方
   * 不广播，不存在 DOM 事件，不写 window.srGlobal
   */
  function emit(event, payload) {
    var callbacks = _callbacks[event] || [];
    for (var i = 0; i < callbacks.length; i++) {
      try { callbacks[i](payload); }
      catch(e) { console.error('[SRController] callback error:', event, e); }
    }
  }

  var _initialized = false;
  var _cartSandboxOpen = false;
  var _popupShown = false;

  // ============================================================
  // 产品页弹窗指令：V层汇报 → C层直接打开（无判断）
  // ============================================================
  if (typeof SRCommand !== 'undefined') {
    SRCommand.onV(SRCommand.CMD.POPUP_OPEN, function() {
      var overlay = document.querySelector('.sr-mp-overlay');
      if (overlay && window.srPopup) {
        srPopup.open(overlay);
      }
    });

    // ── 邮箱提交（Center Explorer / Personal Info） ──
    SRCommand.onV(SRCommand.CMD.EMAIL_SUBMIT, function(payload) {
      return route('email', payload);
    });

    // ── 地址操作 ──
    SRCommand.onV(SRCommand.CMD.ADDRESS_ADD, function(payload) {
      return h_addrAdd(payload.addr);
    });
    SRCommand.onV(SRCommand.CMD.ADDRESS_UPDATE, function(payload) {
      return h_addrUpdate(payload.idx, payload.addr);
    });
    SRCommand.onV(SRCommand.CMD.ADDRESS_DELETE, function(payload) {
      return h_addrDelete(payload.idx);
    });
    SRCommand.onV(SRCommand.CMD.ADDRESS_DEFAULT, function(payload) {
      return h_addrDefault(payload.idx);
    });

    // ── 个人信息操作 ──
    SRCommand.onV(SRCommand.CMD.PROFILE_SAVE, function(payload) {
      return h_saveProfile(payload.data);
    });
    SRCommand.onV(SRCommand.CMD.AVATAR_UPLOAD, function(payload) {
      return h_uploadAvatar(payload.file);
    });
  }

  if (typeof SRModel === 'undefined') {
    console.error('[SRController] SRModel not found');
    return;
  }

  // ============================================================
  // 工具函数
  // ============================================================

  function xhr_get(url) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch (e) { resolve(null); }
        } else if (xhr.status === 404) { resolve(null); }
        else {
          try { var err = JSON.parse(xhr.responseText); reject(new Error(err.error || 'HTTP ' + xhr.status)); }
          catch (e2) { reject(new Error('HTTP ' + xhr.status)); }
        }
      };
      xhr.onerror = function() { reject(new Error('Network error')); };
      xhr.send();
    });
  }

  function xhr_post(url, body) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch (e) { resolve(null); }
        } else if (xhr.status === 409) {
          reject(new Error('already registered'));
        } else if (xhr.status === 429) {
          // v3.21: 解析 retry_after 字段，用于 OTP 频率限制提示
          try {
            var errData = JSON.parse(xhr.responseText);
            var err = new Error(errData.error || 'Rate limited');
            err.retryAfter = errData.retry_after || 60;
            reject(err);
          } catch (e) {
            var err2 = new Error('Rate limited');
            err2.retryAfter = 60;
            reject(err2);
          }
        } else {
          try { var err = JSON.parse(xhr.responseText); reject(new Error(err.error || 'HTTP ' + xhr.status)); }
          catch (e2) { reject(new Error('HTTP ' + xhr.status)); }
        }
      };
      xhr.onerror = function() { reject(new Error('Network error')); };
      xhr.send(JSON.stringify(body));
    });
  }

  function buildMemberData(mid, member, email) {
    return {
      mid: mid,
      email: member.email || email,
      first_name: member.first_name || '',
      last_name: member.last_name || '',
      phone: member.phone || '',
      joined: member.joined || '',
      verified: member.verified || false,
      avatar_url: member.avatar_url || member.avatar || '',
      addresses: member.addresses || [],
      default_address_idx: member.default_address_idx !== undefined ? member.default_address_idx : -1,
      orders: member.orders || []
    };
  }

  // saveAddressesToStorage → 已移至 Model 层

  // ============================================================
  // 统一入口
  // ============================================================

  function route(action, params) {
    params = params || {};
    return handle(action, params).then(function(result) {
      var payload = { stateCode: result.stateCode, data: result.data || {} };
      // 传递 message 和 messageType（如果存在）
      if (result.message) payload.message = result.message;
      if (result.messageType) payload.messageType = result.messageType;
      // 根据 EVENT_MAP 触发对应事件（统一出口：回调 + DOM + 全局）
      var event = EVENT_MAP[action];
      if (event) emit(event, payload);
      // 返回结果给缘起方
      return result;
    });
  }

  // ============================================================
  // 处理模块
  // ============================================================

  function handle(action, params) {
    switch(action) {
      case 'init': return h_init();
      case 'email': return h_email(params.email, params.options);
      case 'otp': return h_otp(params.email);
      case 'update': return h_update(params.data);
      case 'cart.open': return h_cartOpen();
      case 'cart.close': return h_cartClose();
      case 'cart.save': return h_cartSave(params.data);
      case 'profile.avatar': return h_saveAvatar(params.url);
      case 'profile.upload': return h_uploadAvatar(params.file);
      case 'profile.save': return h_saveProfile(params.data);
      case 'addr.list': return h_addrList();
      case 'addr.add': return h_addrAdd(params.addr);
      case 'addr.update': return h_addrUpdate(params.idx, params.addr);
      case 'addr.delete': return h_addrDelete(params.idx);
      case 'addr.default': return h_addrDefault(params.idx);
      case 'orders.list': return h_ordersList();
      case 'orders.detail': return h_ordersDetail(params.no);
      case 'orders.tracking': return h_ordersTracking(params.no);
      case 'orders.note.get': return h_orderNote(params.id);
      case 'orders.note.save': return h_orderNoteSave(params.id, params.note);
      case 'orders.review': return h_orderReview(params.id);
      case 'content.list': return h_contentList(params.filters);
      case 'page.personal-info': return h_pagePersonalInfo();
      default: return Promise.resolve({ stateCode: STATES.ERROR, data: { error: 'Unknown action' } });
    }
  }

  // ── init ──
  function h_init() {
    // 调试模式：?sr_reset=1 强制清除所有SR数据，模拟全新访客
    if (location.search.indexOf('sr_reset=1') !== -1) {
      try {
        var hostname = location.hostname;
        var domain = hostname.indexOf('www.') === 0 ? hostname.substring(4) : hostname;
        if (domain.indexOf('.') !== 0) domain = '.' + domain;
        document.cookie = 'sr_member=;path=/;domain=' + domain + ';max-age=0';
        document.cookie = 'sr_prefs=;path=/;domain=' + domain + ';max-age=0';
        sessionStorage.removeItem('sr_data');
        localStorage.removeItem('sr_popup_shown');
        localStorage.removeItem('sr_cart_sandbox');
        console.log('[SRController] sr_reset=1: all SR data cleared');
      } catch (e) { console.error('[SRController] sr_reset error:', e); }
    }

    if (_initialized) {
      var md = SRModel.get();
      return Promise.resolve({ stateCode: md.mid ? STATES.MEMBER : STATES.VISITOR, data: md });
    }
    return SRModel.init().then(function(md) {
      _initialized = true;
      var result = { stateCode: md.mid ? STATES.MEMBER : STATES.VISITOR, data: md };
      // C层统一调度弹窗：仅白板访客弹出（Insider/PENDING_CONFIRM 不弹）
      // 用 result.stateCode 判断（md.isInsider/md.memberStatus 字段从未被设置）
      var popupShown = localStorage.getItem('sr_popup_shown');
      if (!popupShown && !_popupShown && result.stateCode !== STATES.MEMBER) {
        _popupShown = true;
        var popupDelay = 8; // 默认8秒延迟
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('sr:open-popup'));
          localStorage.setItem('sr_popup_shown', '1');
        }, popupDelay * 1000);
      }
      return result;
    });
  }

  // ── 统一邮箱入口 ──
  function h_email(targetEmail, options) {
    options = options || {};
    var writeLocal = !!options.writeToLocalStorage;
    var preConfirmed = !!options.preConfirmed;

    // 确保 Model 已初始化（防止 Controller.init() 未完成时 SRModel.get() 返回 null）
    var memberData = SRModel.get();
    if (!memberData) {
      console.warn('[SRController] h_email: Model not initialized, data is null');
      memberData = {};
    }

    // C 端统一校验（V 层不应做格式校验，直接扔给 C 端）
    if (!targetEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(targetEmail.trim())) {
      return Promise.resolve({ 
        stateCode: STATES.EMAIL_INVALID, 
        message: 'Invalid email address.',
        messageType: 'error',
        data: memberData 
      });
    }
    targetEmail = targetEmail.trim().toLowerCase();

    var curEmail = ((memberData.email || '')).toLowerCase();
    if (curEmail === targetEmail) {
      return Promise.resolve({ stateCode: STATES.MEMBER, data: SRModel.get() });
    }

    var curMid = (memberData || {}).mid || '';

    return xhr_post(WORKER_URL + '/api/member/sync', { mid: curMid, email: targetEmail })
      .then(function(resp) {
        if (!resp || !resp.mid) return { stateCode: STATES.ERROR, data: { error: 'Sync failed' } };

        if (curMid && !preConfirmed) {
          return { 
            stateCode: STATES.PENDING_CONFIRM, 
            message: 'Please verify to change email.',
            messageType: 'info',
            data: SRModel.get() 
          };
        }

        var md = buildMemberData(resp.mid, resp.member || {}, targetEmail);
        if (writeLocal) {
          SRCommand.dispatch(SRCommand.CMD.EMAIL_REGISTER, md);
        } else {
          SRModel.set(md);
        }
        return { 
          stateCode: STATES.MEMBER, 
          message: 'Welcome, Insider ✦',
          messageType: 'success',
          data: md 
        };

      }).catch(function(err) {
        if (err.message === 'already registered') {
          if (!curMid) return h_lightBoardLogin(targetEmail, options);
          if (preConfirmed) return h_conflict409(targetEmail, options);
          return { 
            stateCode: STATES.PENDING_CONFIRM, 
            message: 'Please verify to change email.',
            messageType: 'info',
            data: SRModel.get() 
          };
        }
        return { 
          stateCode: STATES.ERROR, 
          message: err.message || 'Network error.',
          messageType: 'error',
          data: { error: err.message } 
        };
      });
  }

  // ── 光板登录 ──
  function h_lightBoardLogin(email, options) {
    return xhr_get(WORKER_URL + '/api/member?email=' + encodeURIComponent(email)).then(function(resp) {
      if (!resp || !resp.mid) return { stateCode: STATES.ERROR, data: { error: 'Not found' } };
      var md = buildMemberData(resp.mid, resp.member || resp, email);
      if (options && options.writeToLocalStorage) {
        SRCommand.dispatch(SRCommand.CMD.EMAIL_LOGIN, md);
      } else {
        SRModel.set(md);
      }
      return { stateCode: STATES.MEMBER, data: md };
    });
  }

  // ── 409 冲突 → OTP ──
  function h_conflict409(email, options) {
    return xhr_post(WORKER_URL + '/api/otp/send', { email: email })
      .then(function() { return showOTPModal(email); })
      .then(function(result) {
        if (!result || !result.mid) return { stateCode: STATES.VISITOR, data: SRModel.get() };
        return xhr_post(WORKER_URL + '/api/member/sync', { mid: result.mid, email: email }).then(function(resp) {
          if (!resp || !resp.mid) return { stateCode: STATES.ERROR, data: { error: 'Sync failed' } };
          var md = buildMemberData(resp.mid, resp.member || {}, email);
          if (options && options.writeToLocalStorage) {
            SRCommand.dispatch(SRCommand.CMD.OTP_VERIFY_OK, md);
          } else {
            SRModel.set(md);
          }
          return { stateCode: STATES.MEMBER, data: md };
        });
      }).catch(function(err) {
        if (err.message === 'Cancelled') return { stateCode: STATES.VISITOR, data: SRModel.get() };
        return { stateCode: STATES.ERROR, data: { error: err.message } };
      });
  }

  // ── OTP ──
  function h_otp(email) {
    return xhr_post(WORKER_URL + '/api/otp/send', { email: email })
      .then(function() { return showOTPModal(email); })
      .then(function(result) {
        if (!result || !result.mid) return { stateCode: STATES.ERROR, success: false, data: { error: 'Cancelled' } };
        return { stateCode: STATES.OTP_VERIFIED, success: true, mid: result.mid, email: result.email, data: SRModel.get() };
      });
  }

  // ── update ──
  function h_update(data) {
    var current = SRModel.get() || {};
    var merged = Object.assign({}, current, data);
    SRModel.set(merged);
    return Promise.resolve({ stateCode: STATES.MEMBER, data: SRModel.get() });
  }

  // ── cart ──
  function h_cartOpen() {
    SRCommand.dispatch(SRCommand.CMD.CART_OPEN);
    _cartSandboxOpen = true;
    return Promise.resolve({ stateCode: STATES.VISITOR, data: SRModel.get() });
  }

  function h_cartClose() {
    if (!_cartSandboxOpen) return Promise.resolve({ stateCode: STATES.VISITOR, data: SRModel.get() });
    var sandbox = SRCommand.dispatch(SRCommand.CMD.CART_CLOSE);
    var prev = SRModel.get();
    _cartSandboxOpen = false;
    if (!sandbox) return Promise.resolve({ stateCode: STATES.VISITOR, data: prev });
    if (sandbox.email && sandbox.email !== (prev.email || '')) {
      return h_email(sandbox.email, { writeToLocalStorage: false });
    }
    SRModel.set(Object.assign({}, prev, sandbox));
    var md = SRModel.get();
    return Promise.resolve({ stateCode: md.mid ? STATES.MEMBER : STATES.VISITOR, data: md });
  }

  function h_cartSave(data) {
    if (!_cartSandboxOpen) return Promise.resolve({ stateCode: STATES.ERROR, data: { error: 'Cart not open' } });
    SRCommand.dispatch(SRCommand.CMD.CART_SAVE, data);
    return Promise.resolve({ stateCode: STATES.VISITOR, data: SRModel.get() });
  }

  // ── profile ──
  function h_saveAvatar(url) {
    SRModel.set({ avatar_url: url });
    return Promise.resolve({ stateCode: STATES.MEMBER, data: SRModel.get() });
  }

  function h_uploadAvatar(file) {
    var mid = SRModel.get().mid;
    if (!mid) return Promise.resolve({ stateCode: STATES.ERROR, data: { error: 'Not logged in' } });
    return new Promise(function(resolve) {
      var reader = new FileReader();
      reader.onload = function(e) {
        var b64 = e.target.result;
        if (b64.indexOf(',') !== -1) b64 = b64.split(',')[1];
        xhr_post(WORKER_URL + '/api/avatar/upload', { mid: mid, image: b64 })
          .then(function(resp) {
            if (resp && resp.avatar_url) {
              SRModel.set({ avatar_url: resp.avatar_url });
              resolve({ stateCode: STATES.MEMBER, data: SRModel.get() });
            } else {
              resolve({ stateCode: STATES.ERROR, data: { error: 'Upload failed' } });
            }
          }).catch(function(err) { resolve({ stateCode: STATES.ERROR, data: { error: err.message } }); });
      };
      reader.onerror = function() { resolve({ stateCode: STATES.ERROR, data: { error: 'File read failed' } }); };
      reader.readAsDataURL(file);
    });
  }

  function h_saveProfile(data) {
    var u = {};
    if (data.first_name !== undefined) u.first_name = data.first_name;
    if (data.last_name !== undefined) u.last_name = data.last_name;
    if (data.phone !== undefined) u.phone = data.phone;
    SRModel.set(u);
    return Promise.resolve({ stateCode: STATES.MEMBER, data: SRModel.get() });
  }

  // ── addresses ──
  function h_addrList() {
    var mid = SRModel.get().mid;
    if (!mid) return Promise.resolve({ stateCode: STATES.ERROR, data: { error: 'No mid' } });
    return xhr_get(WORKER_URL + '/api/address?mid=' + encodeURIComponent(mid)).then(function(resp) {
      var addrs = (resp && resp.addresses) || [];
      var defId = resp && resp.default_address_id;
      var defIdx = -1;
      if (defId) for (var i = 0; i < addrs.length; i++) { if (addrs[i].id === defId) { defIdx = i; break; } }
      SRModel.set({ addresses: addrs, default_address_idx: defIdx });
      return { stateCode: STATES.MEMBER, data: SRModel.get() };
    });
  }
  function h_addrAdd(addr) { return SRModel.addressAdd(addr).then(function(r) { return { stateCode: STATES.MEMBER, data: SRModel.get() }; }); }
  function h_addrUpdate(idx, addr) { return SRModel.addressUpdate(idx, addr).then(function() { return { stateCode: STATES.MEMBER, data: SRModel.get() }; }); }
  function h_addrDelete(idx) { return SRModel.addressDelete(idx).then(function() { return { stateCode: STATES.MEMBER, data: SRModel.get() }; }); }
  function h_addrDefault(idx) { return SRModel.addressSetDefault(idx).then(function() { return { stateCode: STATES.MEMBER, data: SRModel.get() }; }); }

  // ── orders ──
  function h_ordersList() {
    var mid = SRModel.get().mid;
    if (!mid) return Promise.resolve({ stateCode: STATES.ERROR, data: { error: 'No mid' } });
    return xhr_get(WORKER_URL + '/api/orders/list?mid=' + encodeURIComponent(mid)).then(function(resp) {
      var orders = (resp && resp.orders) || [];
      SRModel.set({ orders: orders });
      return { stateCode: STATES.MEMBER, data: SRModel.get() };
    });
  }
  function h_ordersDetail(no) { return xhr_get(WORKER_URL + '/api/orders/detail?order=' + encodeURIComponent(no)).then(function(r) { return { stateCode: STATES.MEMBER, data: r }; }); }
  function h_ordersTracking(no) {
    return xhr_get(WORKER_URL + '/api/orders/tracking?order=' + encodeURIComponent(no)).then(function(resp) {
      if (resp && resp.tracking) {
        resp.tracking.current_stage = map4PXStage(resp.tracking);
        resp.tracking.stage_name = STAGE_NAMES[resp.tracking.current_stage] || 'Unknown';
      }
      return { stateCode: STATES.MEMBER, data: resp };
    });
  }
  function h_orderNote(id) { return Promise.resolve({ stateCode: STATES.MEMBER, data: { note: SRModel.orderNoteGet(id) } }); }
  function h_orderNoteSave(id, note) { SRModel.orderNoteSave(id, note); return Promise.resolve({ stateCode: STATES.MEMBER, data: {} }); }
  function h_orderReview(id) { return xhr_get(WORKER_URL + '/api/review?order_id=' + encodeURIComponent(id)).then(function(r) { return { stateCode: STATES.MEMBER, data: r }; }); }

  // ============================================================
  // 4PX 物流
  // ============================================================

  var STAGE_MAP = {
    'FPX_L_RPIF':0,'FPX_C_SPLS':0,'FPX_C_AAF':0,'FPX_C_ADFF':0,'FPX_O_RC':0,
    'FPX_O_DW':1,'FPX_Q_ECC':1,
    'FPX_I_RCUK':2,'FPX_M_ATA':2,'FPX_UNDIFINED':2,
    'FPX_O_RR':3,
    'FPX_O_OFD':4,'FPX_I_OFD':4,
    'FPX_S_OK':5
  };
  var STAGE_NAMES = ['Picked Up','In Transit','Customs Cleared','Last Mile','Out for Delivery','Delivered'];

  function map4PXStage(t) {
    if (!t) return 0;
    if (t.status === 'delivered') return 5;
    var evts = t.events || [], max = -1;
    for (var i = 0; i < evts.length; i++) {
      var s = -1, ev = evts[i];
      if (ev.businessLinkCode && STAGE_MAP[ev.businessLinkCode] !== undefined) s = STAGE_MAP[ev.businessLinkCode];
      if (s === -1 && ev.description) {
        var d = ev.description.toLowerCase();
        if (d.indexOf('delivered') !== -1) s = 5;
        else if (d.indexOf('out for delivery') !== -1) s = 4;
        else if (d.indexOf('last mile') !== -1 || d.indexOf('arrived at local') !== -1) s = 3;
        else if (d.indexOf('cleared customs') !== -1 || d.indexOf('import customs') !== -1) s = 2;
        else if (d.indexOf('departed') !== -1 || d.indexOf('transit') !== -1 || d.indexOf('export customs') !== -1) s = 1;
        else if (d.indexOf('picked up') !== -1 || d.indexOf('order placed') !== -1) s = 0;
      }
      if (s > max) max = s;
    }
    if (max === -1 && t.status === 'in_transit') max = 1;
    return max === -1 ? 0 : max;
  }

  // ============================================================
  // content.list — 统一内容管理
  // ============================================================
  
  var _mockContentData = [
    {
      id: 'five-minute-reset',
      type: 'ritual',
      title: 'The Five-Minute Reset',
      excerpt: 'Light a stick. Close your eyes. That\'s the whole practice — and it\'s enough to shift your entire afternoon. No app required, no optimization needed.',
      url: '/blogs/rituals/five-minute-reset',
      date: '2026-07-18',
      createdAt: '2026-07-18T10:00:00Z',
      featured: true,
      pinned: false,
      visibility: 'all',
      memberOnly: false,
      meta: { readTime: 2 },
      sortWeight: 100
    },
    {
      id: 'evening-winding-down',
      type: 'ritual',
      title: 'Evening Winding Down',
      excerpt: 'How a single scent can signal to your body that the day is done and rest can begin. A simple evening protocol for those who struggle to switch off.',
      url: '/blogs/rituals/evening-winding-down',
      date: '2026-07-12',
      createdAt: '2026-07-12T08:00:00Z',
      featured: false,
      pinned: false,
      visibility: 'all',
      memberOnly: false,
      meta: { readTime: 3 },
      sortWeight: 50
    },
    {
      id: 'origins-of-sandalwood',
      type: 'journal',
      title: 'The Origins of Sandalwood',
      excerpt: 'From the red soils of Mysore to your desktop — a brief history of the world\'s most contemplative wood. We trace the journey from ancient groves to modern rituals, exploring why this single ingredient has captivated civilizations for millennia.',
      url: '/blogs/journal/origins-of-sandalwood',
      date: '2026-07-20',
      createdAt: '2026-07-20T06:00:00Z',
      featured: false,
      pinned: false,
      visibility: 'all',
      memberOnly: false,
      meta: { readTime: 8 },
      sortWeight: 50
    },
    {
      id: 'scent-path-to-calm',
      type: 'journal',
      title: 'Why Scent Is the Shortest Path to Calm',
      excerpt: 'The olfactory system bypasses the thinking brain entirely. Before you can analyze a fragrance, your body has already begun to respond. Here\'s the science behind why incense works when meditation apps don\'t.',
      url: '/blogs/journal/scent-path-to-calm',
      date: '2026-07-08',
      createdAt: '2026-07-08T12:00:00Z',
      featured: false,
      pinned: false,
      visibility: 'all',
      memberOnly: false,
      meta: { readTime: 6 },
      sortWeight: 50
    },
    {
      id: 'summer-solstice-collection',
      type: 'event',
      title: 'Summer Solstice Collection',
      excerpt: 'A limited offering for the longest days. Light, citrus-forward blends designed for golden-hour stillness. Available to Insiders first.',
      url: '/pages/summer-solstice',
      date: '2026-07-15',
      createdAt: '2026-07-15T00:00:00Z',
      featured: true,
      pinned: false,
      visibility: 'insider',
      memberOnly: true,
      meta: { startDate: '2026-07-15', endDate: '2026-08-31' },
      sortWeight: 80
    }
  ];
  
  function sortContentItems(items) {
    return items.slice().sort(function(a, b) {
      if (!!a.pinned !== !!b.pinned) return a.pinned ? -1 : 1;
      if (!!a.featured !== !!b.featured) return a.featured ? -1 : 1;
      var wa = a.sortWeight || 0, wb = b.sortWeight || 0;
      if (wa !== wb) return wb - wa;
      var da = a.date || '', db = b.date || '';
      if (da !== db) return da > db ? -1 : 1;
      return 0;
    });
  }
  
  function h_contentList(filters) {
    filters = filters || {};
    var allItems = _mockContentData.slice();
    
    if (filters.type) {
      allItems = allItems.filter(function(item) { return item.type === filters.type; });
    }
    if (filters.visibility) {
      var isMember = _initialized && !!((SRModel.get() || {}).mid);
      allItems = allItems.filter(function(item) {
        var v = item.visibility || 'all';
        if (v === 'all') return true;
        if (v === 'insider') return isMember;
        if (v === 'explorer') return !isMember;
        return true;
      });
    }
    var now = new Date().toISOString().split('T')[0];
    allItems = allItems.filter(function(item) {
      if (item.type === 'event' && item.meta && item.meta.endDate) {
        return item.meta.endDate >= now;
      }
      return true;
    });
    allItems = sortContentItems(allItems);
    if (filters.limit && filters.limit > 0) {
      allItems = allItems.slice(0, filters.limit);
    }
    return Promise.resolve({ stateCode: 1, data: { items: allItems, total: allItems.length } });
  }

  // ── Personal Info 页面入口（OTP 验证后跳转） ──
  function h_pagePersonalInfo() {
    var md = SRModel.get() || {};
    var email = md.email;
    if (!email) return Promise.resolve({ stateCode: STATES.ERROR, data: { error: 'No email' } });
    return h_otp(email).then(function(result) {
      if (result.stateCode === STATES.OTP_VERIFIED) {
        return { stateCode: STATES.OTP_VERIFIED, data: SRModel.get(), navigate: '/pages/personal-info' };
      }
      return result;
    });
  }

  // ============================================================
  // OTP 弹窗
  // ============================================================

  function showOTPModal(email) {
    return new Promise(function(resolve, reject) {
      var overlay = document.createElement('div');
      overlay.id = 'sr-otp-modal-overlay';
      overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:9999999;display:flex;align-items:center;justify-content:center;';
      overlay.innerHTML =
        '<div style="position:relative;background:#FDFBF7;border:1px solid #e0d5c1;border-radius:12px;padding:28px 24px 20px;max-width:400px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.15);font-family:inherit;">' +
          '<button id="sr-otp-close-x" type="button" style="position:absolute;top:10px;right:14px;background:none;border:none;font-size:22px;color:#999;cursor:pointer;line-height:1;padding:4px;">×</button>' +
          '<div style="font-size:17px;font-weight:600;color:#451A00;margin-bottom:12px;text-align:center;">Enter Verification Code</div>' +
          '<div style="font-size:14px;color:#666;margin-bottom:20px;text-align:center;"><strong style="color:#451A00;">' + email + '</strong></div>' +
          '<div id="sr-otp-inputs" style="display:flex;justify-content:center;gap:8px;margin-bottom:16px;">' +
            '<input type="tel" maxlength="1" class="sr-otp-digit" style="width:42px;height:52px;text-align:center;font-size:22px;font-weight:600;border:1px solid #d4c5a9;border-radius:8px;background:#fff;color:#451A00;outline:none;">' +
            '<input type="tel" maxlength="1" class="sr-otp-digit" style="width:42px;height:52px;text-align:center;font-size:22px;font-weight:600;border:1px solid #d4c5a9;border-radius:8px;background:#fff;color:#451A00;outline:none;">' +
            '<input type="tel" maxlength="1" class="sr-otp-digit" style="width:42px;height:52px;text-align:center;font-size:22px;font-weight:600;border:1px solid #d4c5a9;border-radius:8px;background:#fff;color:#451A00;outline:none;">' +
            '<input type="tel" maxlength="1" class="sr-otp-digit" style="width:42px;height:52px;text-align:center;font-size:22px;font-weight:600;border:1px solid #d4c5a9;border-radius:8px;background:#fff;color:#451A00;outline:none;">' +
            '<input type="tel" maxlength="1" class="sr-otp-digit" style="width:42px;height:52px;text-align:center;font-size:22px;font-weight:600;border:1px solid #d4c5a9;border-radius:8px;background:#fff;color:#451A00;outline:none;">' +
            '<input type="tel" maxlength="1" class="sr-otp-digit" style="width:42px;height:52px;text-align:center;font-size:22px;font-weight:600;border:1px solid #d4c5a9;border-radius:8px;background:#fff;color:#451A00;outline:none;">' +
          '</div>' +
          '<div id="sr-otp-error" style="font-size:12px;color:#c0392b;text-align:center;margin-bottom:12px;min-height:16px;"></div>' +
          '<button id="sr-otp-verify-btn" type="button" disabled style="width:100%;padding:14px;background:#451A00;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;opacity:0.5;transition:opacity .15s;">Verify</button>' +
          '<div style="text-align:center;margin-top:12px;"><button id="sr-otp-resend-btn" type="button" disabled style="background:none;border:none;color:#8b7355;font-size:12px;cursor:pointer;text-decoration:underline;">Resend code (<span id="sr-otp-countdown">60</span>s)</button></div>' +
        '</div>';
      document.body.appendChild(overlay);

      var inputs = overlay.querySelectorAll('.sr-otp-digit');
      var verifyBtn = overlay.querySelector('#sr-otp-verify-btn');
      var resendBtn = overlay.querySelector('#sr-otp-resend-btn');
      var countdownEl = overlay.querySelector('#sr-otp-countdown');
      var errorEl = overlay.querySelector('#sr-otp-error');
      var timer = null, resolved = false;

      function close() {
        if (timer) clearInterval(timer);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }
      function getCode() { var c = ''; for (var i = 0; i < inputs.length; i++) c += inputs[i].value || ''; return c; }
      function updateBtn() {
        var c = getCode();
        verifyBtn.disabled = c.length !== 6;
        verifyBtn.style.opacity = c.length === 6 ? '1' : '0.5';
      }

      for (var i = 0; i < inputs.length; i++) {
        (function(idx) {
          inputs[idx].addEventListener('input', function(e) {
            var v = e.target.value.replace(/[^0-9]/g, '');
            e.target.value = v.charAt(0) || '';
            errorEl.textContent = '';
            if (v && idx < inputs.length - 1) inputs[idx + 1].focus();
            updateBtn();
            if (getCode().length === 6) setTimeout(function() { verifyBtn.click(); }, 100);
          });
          inputs[idx].addEventListener('keydown', function(e) {
            if (e.key === 'Backspace' && !e.target.value && idx > 0) { inputs[idx-1].focus(); inputs[idx-1].value = ''; updateBtn(); }
          });
          inputs[idx].addEventListener('paste', function(e) {
            e.preventDefault();
            var p = (e.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '');
            for (var j = 0; j < 6 && j < p.length; j++) inputs[j].value = p.charAt(j);
            if (p.length >= 6) inputs[5].focus(); else if (p.length > 0) inputs[Math.min(p.length, 5)].focus();
            updateBtn();
          });
        })(i);
      }

      var rem = 60;
      timer = setInterval(function() {
        rem--;
        if (countdownEl) countdownEl.textContent = rem;
        if (rem <= 0) { clearInterval(timer); resendBtn.disabled = false; resendBtn.textContent = 'Resend code'; }
      }, 1000);

      resendBtn.addEventListener('click', function() {
        if (resendBtn.disabled) return;
        xhr_post(WORKER_URL + '/api/otp/send', { email: email }).then(function() {
          errorEl.textContent = '';
          resendBtn.disabled = true; rem = 60; countdownEl.textContent = rem;
          resendBtn.textContent = '';
          var s1 = document.createElement('span'); s1.textContent = 'Resend code (';
          resendBtn.appendChild(s1); resendBtn.appendChild(countdownEl);
          var s2 = document.createElement('span'); s2.textContent = 's)'; resendBtn.appendChild(s2);
          timer = setInterval(function() { rem--; countdownEl.textContent = rem; if (rem <= 0) { clearInterval(timer); resendBtn.disabled = false; resendBtn.textContent = 'Resend code'; } }, 1000);
          for (var i = 0; i < inputs.length; i++) inputs[i].value = '';
          inputs[0].focus(); updateBtn();
        }).catch(function(err) {
          // v3.21: 使用后端返回的错误信息，支持 retryAfter 显示等待时间
          if (err.retryAfter) {
            errorEl.textContent = 'Wait ' + err.retryAfter + 's';
          } else {
            errorEl.textContent = err.message || 'Failed to send.';
          }
        });
      });

      verifyBtn.addEventListener('click', function() {
        var code = getCode(); if (code.length !== 6) return;
        verifyBtn.disabled = true; verifyBtn.textContent = 'Verifying...';
        xhr_post(WORKER_URL + '/api/otp/verify', { email: email, code: code }).then(function(result) {
          if (result.success) { resolved = true; close(); resolve(result); }
        }).catch(function(err) {
          // v3.21: 使用后端返回的错误信息，如 "Verification code expired or not found" 或 "Invalid verification code"
          errorEl.textContent = err.message || 'Invalid code.';
          verifyBtn.disabled = false; verifyBtn.textContent = 'Verify';
          for (var i = 0; i < inputs.length; i++) inputs[i].value = '';
          inputs[0].focus(); updateBtn();
        });
      });

      overlay.querySelector('#sr-otp-close-x').addEventListener('click', function() { close(); if (!resolved) reject(new Error('Cancelled')); });
      overlay.addEventListener('click', function(e) { if (e.target === overlay) { close(); if (!resolved) reject(new Error('Cancelled')); } });
      function onEsc(e) { if (e.key === 'Escape') { document.removeEventListener('keydown', onEsc); close(); if (!resolved) reject(new Error('Cancelled')); } }
      document.addEventListener('keydown', onEsc);
      setTimeout(function() { inputs[0].focus(); }, 100);
    });
  }

  // ============================================================
  // 出口写盘：离开网站时统一写 Cookie + KV
  // ============================================================

  window.addEventListener('beforeunload', function() {
    if (typeof SRCommand !== 'undefined') {
      SRCommand.dispatch(SRCommand.CMD.PAGE_EXIT);
    }
  });

  // ============================================================
  // 对外 API
  // ============================================================

  window.SRController = {
    STATES: STATES,
    route: route,

    init: function() { return route('init'); },
    processEmailInput: function(email, opts) { return route('email', { email: email, options: opts }); },
    setEmail: function(email, opts) { return route('email', { email: email, options: opts }); },
    verifyOTP: function(email) { return route('otp', { email: email }); },
    isMember: function() { return !!(SRModel.get() || {}).mid; },
    get: function() { return SRModel.get(); },
    lookup: function(email) { return xhr_get(WORKER_URL + '/api/member?email=' + encodeURIComponent(email)); },
    update: function(data) { return route('update', { data: data }); },

    cart: {
      open: function() { return route('cart.open'); },
      close: function() { return route('cart.close'); },
      save: function(data) { return route('cart.save', { data: data }); },
      getSnapshot: function() { return window._srCartSnapshot || SRModel.get(); },
      isOpen: function() { return _cartSandboxOpen; }
    },

    profile: {
      saveAvatar: function(url) { return route('profile.avatar', { url: url }); },
      uploadAvatar: function(file) { return route('profile.upload', { file: file }); },
      saveProfile: function(data) { return route('profile.save', { data: data }); },
      getProfile: function() {
        var d = SRModel.get();
        return { first_name: d.first_name||'', last_name: d.last_name||'', phone: d.phone||'', email: d.email||'', avatar_url: d.avatar_url||'' };
      }
    },

    addresses: {
      getList: function() { return route('addr.list'); },
      add: function(a) { return route('addr.add', { addr: a }); },
      update: function(i, a) { return route('addr.update', { idx: i, addr: a }); },
      delete: function(i) { return route('addr.delete', { idx: i }); },
      setDefault: function(i) { return route('addr.default', { idx: i }); }
    },

    orders: {
      getList: function() { return route('orders.list'); },
      getDetail: function(n) { return route('orders.detail', { no: n }); },
      getTracking: function(n) { return route('orders.tracking', { no: n }); },
      getNote: function(id) { return route('orders.note.get', { id: id }); },
      saveNote: function(id, n) { return route('orders.note.save', { id: id, note: n }); },
      getReview: function(id) { return route('orders.review', { id: id }); }
    },

    content: {
      list: function(filters) { return route('content.list', { filters: filters }); }
    },

    page: {
      personalInfo: function() { return route('page.personal-info'); }
    },

    map4PXStage: map4PXStage,
    STAGE_NAMES: STAGE_NAMES,
    on: on,

    /* ── Popup Engine: C层判定弹窗是否应该弹 ── */
    shouldShowPopup: function(popupId) {
      var md = SRModel.get();
      // Insider → 不弹注册弹窗
      if (md && md.isInsider) return false;
      // PENDING_CONFIRM → Controller 自行处理 OTP，不弹注册
      if (md && md.memberStatus === 'PENDING_CONFIRM') return false;
      // 其他情况 → 可以弹
      return true;
    }
  };

  console.log('[SRController] v3.15r8 ready');
})();


